// Third-party libraries
import React from "react";
import { useLocation } from "react-router-dom";
import { Link as DomLink } from "react-router-dom";
import parse from "html-react-parser";
import HelpIcon from "@mui/icons-material/Help";
import CameraAlt from "@mui/icons-material/CameraAlt";
import { GemstoneTypes } from "./GemstoneType";
import GemstoneCollections from "./GemstoneCollections";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  Stack,
  Typography,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

// Local modules
import ShapeFilter from "../diamonds/controls/filters/ShapeFilter";
import { Range, RangeNominal } from "../diamonds/controls/filters";
import CheckBox from "./filter/CheckBoxes";
import CustomSwitch from "../diamonds/styles/CustomSwitch";
import { GemstoneColors } from "./GemstoneColors";

function AccordionGemstoneFilter(props) {
  const sendTo = useLocation();

  const { updateNominalRange, resetFilters } = props;

  function renderFilterControl(filter) {
    if (filter.type === "options") {
      if (filter.label === "Shape") {
        return (
          <ShapeFilter state={props.gemstoneState} dispatch={props.dispatch} />
        );
      }
      return (
        <CheckBox
          search={props.searchQuery}
          filter={filter}
          resetFilters={resetFilters}
          updateCheckedBoxes={props.updateCheckedBoxes}
        />
      );
    }

    if (filter.type === "enum") {
      if (filter.name === "Color") {
        return (
          <GemstoneColors
            filter={filter}
            searchQuery={props.searchQuery}
            dispatch={props.dispatch}
          />
        );
      }
      if (filter.name === "Gemstone") {
        return (
          <GemstoneTypes
            filter={filter}
            searchQuery={props.searchQuery}
            dispatch={props.dispatch}
          />
        );
      }
      return (
        <RangeNominal
          filter={filter}
          resetFilters={resetFilters}
          updateNominalRange={updateNominalRange}
          color={"primary"}
        />
      );
    }

    if (filter.type === "numeric" && filter.name !== "HooverPrice") {
      return (
        <Range
          filter={filter}
          resetFilters={resetFilters}
          updateRange={props.updateRange}
          color={"primary"}
        />
      );
    }

    if (filter.name === "HooverPrice") {
      if (!props.loggedIn) {
        return (
          <DomLink
            to={{
              pathname: "/login",
              state: { sendTo: sendTo.pathname },
            }}
          >
            <Button variant="contained" color="error">
              Login For pricing
            </Button>
          </DomLink>
        );
      }
      return (
        <Range
          filter={filter}
          resetFilters={resetFilters}
          updateRange={props.updateRange}
          color={"primary"}
        />
      );
    }

    return null;
  }

  return (
    <>
      <Stack spacing={1} alignItems="center">
        <GemstoneCollections
          collection={props.collection}
          clearFilters={props.clearFilters}
          valueForColor={props.valueForColor}
        />
        {props.filters &&
          props.filters.map((filter) => (
            <Accordion
              key={filter.name}
              square={true}
              disableGutters={true}
              sx={{ width: "100%", minHeight: "unset", paddingRight: "1rem" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                  }}
                >
                  {filter.label}
                  {filter.label === "Source" || filter.label === "Features" ? (
                    <DomLink
                      to={{
                        pathname: "/sub-landing/Diamond-Sources",
                      }}
                      target="_blank"
                    >
                      <HelpIcon className="help-icon question-mark" />
                    </DomLink>
                  ) : (
                    <>
                      {filter.label !== "Price" && (
                        <HelpIcon
                          className="help-icon question-mark"
                          onClick={() =>
                            props.dispatch({
                              type: "setOpenHelpText",
                              payload: {
                                open: true,
                                label: filter.label,
                                text: parse(filter.help_text),
                              },
                            })
                          }
                        />
                      )}
                    </>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>{renderFilterControl(filter)}</AccordionDetails>
            </Accordion>
          ))}
        <Stack spacing={1} sx={{ paddingBottom: "2rem" }}>
          <FormControlLabel
            control={
              <CustomSwitch
                id="ImageVideoAvailable"
                type="checkbox"
                sx={{ marginLeft: "1rem" }}
                onChange={(e) =>
                  props.updateCheckedBoxes("ImageVideoAvailable", {
                    name: "ImageVideoAvailable",
                    checked: e.target.checked ? "Y" : "N",
                  })
                }
              />
            }
            label={
              <Typography
                variant="body3"
                sx={{ fontWeight: "800", marginLeft: "2rem" }}
              >
                Image/Video Available <CameraAlt color="primary" />
              </Typography>
            }
          />
        </Stack>
      </Stack>
    </>
  );
}

export default AccordionGemstoneFilter;
